import axios from "axios";
import { apiUrl } from "../constant";

export const getOrderByLabelService = (data) => {
    return axios.post(`${apiUrl}/api/PackVerification/GetOrderByLabel`, data);
};

export const getOrderItemsService = (data) => {
    return axios.post(`${apiUrl}/api/PackVerification/GetOrderItems`, data);
};

export const scanPackItemService = (data) => {
    return axios.post(`${apiUrl}/api/PackVerification/ScanItem`, data);
};

export const completePackVerificationService = (data) => {
    return axios.post(`${apiUrl}/api/PackVerification/Complete`, data);
};

export const resetPackVerificationService = (data) => {
    return axios.post(`${apiUrl}/api/PackVerification/Reset`, data);
};
